import { FormValues } from 'app/pages/Registration/utils';

export const hardwareToTextMap = (key: string): string => {
  const map: Record<string, string> = {
    androidTablet: 'Android Tablet',
    iosTablet: 'IOS Tablet',
    starPortableBluetoothReceiptPrinter:
      'Star Portable Bluetooth receipt printer',
    starDesktopBluetoothReceiptPrinter:
      'Star Desktop Bluetooth receipt printer (with cashdrawer connection)',
    starDesktopNetworkLanReceiptPrinter:
      'Star Desktop network (LAN) receipt printer (with cashdrawer connection)',
    starDesktopNetworkWifiReceiptPrinter:
      'Star Desktop network (WiFi) receipt printer (with cashdrawer connection)',
    starDesktopBluetoothPrinterCashDrawerMpop:
      'Star Desktop Bluetooth printer-cashdrawer mPOP',
    desktopNetworkLanReceiptPrinter:
      'Desktop network (LAN) receipt printer (with cash drawer connection)',
    desktopNetworkWifiReceiptPrinter:
      'Desktop network (WiFi) receipt printer (with cash drawer connection)',
    desktopWiredCashDrawer: 'Desktop wired cashdrawer',
    linearBluetoothBarcodeReader: 'Linear Bluetooth barcode reader',
    twoDBluetoothBarcodeReader: '2D Bluetooth barcode reader',
    win10DesktopComputer: 'All-in-one desktop computer, Windows 10 IoT',
    win10DesktopComputerWithIntegratedReceiptPrinter:
      'All-in-one desktop computer, Windows 10 IoT, with integrated receipt printer',
    usbReceiptPrinter:
      'Desktop USB receipt printer (with cash drawer connection)',
    wiredLinearBarcodeReader: 'Wired USB linear barcode reader',
    wiredUSB2DBarcodeReader: 'boolean',
    wireless2DBluetoothBarcodeReader: 'boolean',
    desktopScale: 'boolean',
    hasNeededHardware: 'Customer has all the hardware the customer need',
  };
  return map[key];
};

export const getHardwareNeeds = (
  hardware: Record<string, FormValues>,
): string =>
  Object.entries(hardware)
    .filter(([, value]) => value)
    .map(([key]) => `- ${hardwareToTextMap(key)}`)
    .join('\n');

export const getPrice = ({
  month,
  period,
  year,
  locations,
}: {
  locations: FormValues;
  month: number;
  year: number;
  period: 'annual' | 'monthly';
}): number => Number(locations ?? 0) * (period === 'monthly' ? month : year);
